// extracted by mini-css-extract-plugin
export default {"container":"cykWf","infoContainer":"u59f0","smallText":"UkIzP","headerButton":"W8eoM","checkbox":"GTJ+U"};